import React, {Component} from 'react'
import PropTypes from "prop-types"

class ResetFilters extends Component {

    render() {
        const {onResetFilters} = this.props

        return (
            <div className="ResetFilters">
                <button onClick={onResetFilters} className="btn btn-outline-dark"><i className="icon-spinner11 mr-1"/> Reset filters</button>
            </div>
        )
    }
}

ResetFilters.propTypes = {
    onResetFilters: PropTypes.func.isRequired
}

export default ResetFilters